// İSG uzmanı portalı — yapay zekâ tanıma işareti (GL #7, tasarım review §3 / D-6). Sessiz bir
// METİN işaretidir: `Tag` DEĞİL (durum sütununda ikinci bir hap gürültüdür), `Tooltip` YOK (Sheet /
// Modal örtüsünün altında açılır). Sınıflandırmanın kaynağını söyler; geçerlilik ya da onay durumu
// DEĞİLDİR.
//
// İki kullanıcı: Belge Şemaları listesinin "AI tanıma" hücresi (Task 2) ve uzmanın personel belge
// satırları (`DocumentRow` `provenance`, Task 3a). Sürüm varken `ScanText` simgesi + "AI v{n}";
// yokken yalnız metin. Satır bağlamındaki tam cümle ekran okuyucuya `srText` ile verilir; verildiğinde
// görünen kısa metin AT'den gizlenir (iki kez okunmasın).

import { ScanText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface RecognitionMarkProps {
  /** Tanıyan canlı doc-check sürümü; `null` = yapay zekâ doğrulaması yok. */
  release: number | null;
  /** `release === null` iken görünen metin. Varsayılan: "AI tanıması yok" (belge satırı). */
  noneText?: string;
  /**
   * Ekran okuyucu cümlesi. Verilmezse: sürüm varken belge satırının cümlesi, yokken hiçbiri.
   * `null` = cümle yok (görünen metin okunur).
   */
  srText?: string | null;
}

export function RecognitionMark({ release, noneText, srText }: RecognitionMarkProps) {
  const { t } = useTranslation();

  // `typeof` (`!== null` DEĞİL): alanı henüz göndermeyen bir API `undefined` verir; bu "AI
  // doğrulaması yok" okunur, asla "AI vundefined" değil.
  if (typeof release === 'number') {
    const sr = srText === undefined ? t('documents.recognition.srSet', { n: release }) : srText;
    return (
      <span className="inline-flex items-center gap-1 text-xs text-muted">
        <ScanText className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        <span aria-hidden={sr ? true : undefined}>
          {t('documents.recognition.set', { n: release })}
        </span>
        {sr ? <span className="sr-only">{sr}</span> : null}
      </span>
    );
  }

  return (
    <span className="text-xs text-muted">
      <span aria-hidden={srText ? true : undefined}>
        {noneText ?? t('documents.recognition.none')}
      </span>
      {srText ? <span className="sr-only">{srText}</span> : null}
    </span>
  );
}
